import cn from 'classnames';
import React from 'react';

import styles from './navigation-sidebar.module.scss';

interface NavigationSidebarProps {
  readonly open?: boolean;
}

/**
 * A sidebar variant of the main menu.
 */
const NavigationSidebar: React.FC<
  React.PropsWithChildren<NavigationSidebarProps>
> = ({ open = false, children }) => {
  return (
    <aside
      className={cn(styles.container, {
        [styles.isOpen]: open,
      })}
    >
      <nav className={styles.inner}>{children}</nav>
    </aside>
  );
};

export default NavigationSidebar;
